import { createIcon } from './icon-resolver'
import {
  CONTEXT_MENU_ERROR,
  DefaultContextMenuItemOrder,
  SHORTHANDS,
  SHORTHAND_ITEMS,
} from '../models/context-menu.constants'
import { get, isArray, isBoolean, isEmpty, isFunction, isObject, isString, isUndefined, isNumber } from 'lodash'
import { setDefaultItems } from './context-menu.factory'
import { ContextItemTypes, ContextMenuItem } from '../models/context-menu.types'

function getDefaultOrderByType(item: ContextMenuItem, index: number, itemsLength: number): {} {
  let order = DefaultContextMenuItemOrder.find((el) => el.type === item.type)?.order ?? item?.order

  if (isNumber(order)) {
    if (order > itemsLength) {
      order = itemsLength - 1
    }

    return {
      order,
      hasOrderPriority: true,
    }
  }

  return {
    order: index,
    hasOrderPriority: false,
  }
}

export function filterContextMenu(item: unknown) {
  if (isObject(item)) {
    const { name, icon, action, disabled, permissionKey, type, confirmModalConfig, subMenu, ...restItemKeys } =
      item as Record<string, any>

    if (!isEmpty(restItemKeys)) {
      console.error(CONTEXT_MENU_ERROR)
      return false
    }

    if (
      (!isUndefined(name) && !isString(name)) ||
      (!isUndefined(icon) && !isString(icon)) ||
      (!isUndefined(action) && !isFunction(action)) ||
      (!isUndefined(disabled) && !isBoolean(disabled)) ||
      (!isUndefined(permissionKey) && !isString(permissionKey)) ||
      (!isUndefined(type) && !isString(type)) ||
      (!isUndefined(confirmModalConfig) && !isObject(confirmModalConfig))
    ) {
      console.error(CONTEXT_MENU_ERROR)
      return false
    }
  } else if (isString(item)) {
    if (!SHORTHAND_ITEMS.includes(item as SHORTHANDS)) {
      console.error(CONTEXT_MENU_ERROR)
      return false
    }
  }

  return true
}

export function mapContextMenuItems(items: ContextMenuItem[], context) {
  const { permissions, setConfirmationConfig } = context

  if (!isArray(items)) {
    console.error(CONTEXT_MENU_ERROR)
    return []
  }

  return items
    .filter(filterContextMenu)
    .map((item: ContextMenuItem) => {
      if (isObject(item) && isString(item.icon)) {
        return {
          ...item,
          icon: createIcon(item.icon),
          type: item?.type ? item?.type : (item.icon as ContextItemTypes),
        }
      }
      return setDefaultItems.call(context, item)
    })
    .reduce((accumulator, item) => {
      if (Array.isArray(item)) {
        item.forEach((i) => {
          accumulator.push(i)
        })
      } else {
        accumulator.push(item)
      }

      return accumulator
    }, [] as ContextMenuItem[])
    .filter((item: ContextMenuItem) =>
      isObject(item) && isString(item.permissionKey) ? permissions[item.permissionKey] === true : true,
    )
    .map((item: ContextMenuItem) => {
      const { confirmModalConfig } = item
      if (isObject(confirmModalConfig)) {
        const {
          confirmModalConfig: { message },
          action,
          ...restItems
        } = item

        return {
          ...restItems,
          action: () => {
            if (isFunction(action)) {
              setConfirmationConfig({
                action,
                message,
              })
            }
          },
        }
      }
      return item
    })
    .map((item) => {
      const subMenu = get(item, 'subMenu')
      if (!isUndefined(subMenu)) {
        return {
          ...item,
          subMenu: mapContextMenuItems(subMenu, context),
        }
      }
      return item
    })
    .map((item: ContextMenuItem, idx: number, items: ContextMenuItem[]) => ({
      ...item,
      ...getDefaultOrderByType(item, idx, items.length),
    }))
    .sort((a, b) => (a.order > b.order ? 0 : -1))
    .sort((a, b) => (a.hasOrderPriority === b.hasOrderPriority ? 0 : a.hasOrderPriority ? -1 : 1))
}
